<template>
  <main class="main" tabindex="0">
    <div v-html="contact.contact" />
    <div v-if="!success" class="newsletter-form">
      <input
        type="text"
        name="firstname"
        placeholder="First name"
        v-model="firstname"
        required
      />
      <input
        type="text"
        name="lastname"
        placeholder="Last name"
        v-model="lastname"
        required
      />
      <input
        type="email"
        name="email"
        placeholder="Email"
        v-model="email"
        required
      />
      <input
        :disabled="!this.email"
        type="submit"
        name="submit"
        value="Subcribe to our newsletter"
        @click="subscribe"
      />
    </div>
    <div v-else>Thank you.</div>
    <div class="mt" v-html="contact.text" />
  </main>
</template>

<script>
import axios from "axios";
const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD
};
import { mapState } from "vuex";
export default {
  name: "contact",
  metaInfo() {
    return {
      title: "- Contact"
    };
  },
  data() {
    return {
      success: false,
      email: null,
      firstname: null,
      lastname: null
    };
  },
  computed: mapState(["contact"]),
  methods: {
    subscribe() {
      axios
        .post(
          "/api/subscribe",
          {
            email: this.email,
            firstname: this.firstname,
            lastname: this.lastname
          },
          { auth }
        )
        .then(() => {
          this.success = true;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/defaults.scss";
input {
  appearance: none;
  outline: none;
  font-family: "Med", Helvetica, Arial, sans-serif;
  font-size: var(--font-size);
  line-height: var(--line-height);
  border: 0;
  border-radius: 0;
  padding: 0;
  background: transparent;
  @media only screen and (max-width:768px) {
    font-size: calc(2 * var(--font-size));
  }
  &::placeholder {
    color: var(--color2);
  }
  &[type="text"] {
    width: 100%;
  }
  &[type="email"] {
    width: 100%;
  }
  &[type="submit"] {
    color: var(--color2);
    &:disabled {
      color: black;
    }
    &:hover {
      color: black;
      cursor: pointer;
    }
  }
}
</style>
